import React from 'react';
import ReactEcharts from 'echarts-for-react';
import PropTypes from 'prop-types';

const OtifLineChart = ({ months, data, title }) => {
  const option = {
    tooltip: {
      trigger: 'axis',
      formatter: params => `${params[0].axisValueLabel}<br/>${params[0].value}%`
    },
    grid: { left: '5%', right: '3%', top: '15%', bottom: '10%', containLabel: true },
    xAxis: {
      type: 'category',
      data: months,
      axisLabel: { fontSize: 11 }
    },
    yAxis: {
      type: 'value',
      min: 40,
      max: 100,
      axisLabel: { formatter: '{value}%' }
    },
    series: [
      {
        name: title,
        type: 'line',
        data,
        smooth: true,
        symbol: 'circle',
        symbolSize: 6,
        lineStyle: { color: '#2c7be5', width: 2 },
        itemStyle: { color: '#2c7be5' },
        areaStyle: { color: 'rgba(44,123,229,0.08)' }
      }
    ]
  };

  return <ReactEcharts option={option} style={{ height: 220 }} />;
};

OtifLineChart.propTypes = {
  months: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.number).isRequired,
  title: PropTypes.string
};

OtifLineChart.defaultProps = { title: 'OTIF %' };

export default OtifLineChart;
